












































































































































import TheA01Carousel from "@/general/components/pages/parts/Top/TheA01Carousel.vue";
import TheA01PointInfoPanel from "@/general/components/pages/parts/Top/TheA01PointInfoPanel.vue";
import TheA01PointNoticeCard from "@/general/components/pages/parts/Top/TheA01PointNoticeCard.vue";
import A01Heading from "@/general/components/pages/parts/Top/A01Heading.vue";
import TheA01MessagePanel from "@/general/components/pages/parts/Top/TheA01MessagePanel.vue";
import TextLink from "@/common/components/atoms/TextLink.vue";
import ItemList from "@/general/components/organisms/ItemList.vue";

import TheSideMenu from "@/general/components/organisms/TheSideMenu.vue";
import LinkToThanksPointPagePanel from "@/general/components/organisms/LinkToThanksPointPagePanel.vue";
import CMS from "@/general/components/CMS.vue"

import {
  UserProfileSummary,
  UserPointAchievement,
  PointNoticeCard,
  RandomUserAvatar,
  LatestMessage
} from "@/general/store/models";
import { Prop, Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

import commons from "@/common/store/modules/commons";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

import TopPageApi from "@/general/api/topPageApi";
import auth from "@/general/store/modules/auth";
import { getUserProfileSummary } from "@/general/store/api";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    TheA01Carousel,
    TheA01PointInfoPanel,
    TheA01PointNoticeCard,
    A01Heading,
    TheA01MessagePanel,
    TextLink,
    LinkToThanksPointPagePanel,
    TheSideMenu,
    ItemList,
    CMS
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class TopPage extends Vue {
  @Prop({ type: String, required: false, default: "" }) modal!: string;

  storeColorCode: string;
  headerHeightToChild = 0;
  pointNoticeCards: PointNoticeCard[] = [];
  theA01PointInfo = {
    pointsLoaded: false,
    pointAchievements: {},
    point: 0,
    pointsExpiringSoon: 0,
    pointsExpiringCount: 0,
    grantPoints: 0,
    thanksExclusivePoint: 0,
    groupBudgetPoint: 0
  };
  members: RandomUserAvatar[] = [];
  messages: any = [];

  $refs!: {
    theHeader: any;
  };

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get color(): string {
    return this.colorCode;
  }
  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }
  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }
  get isSp(): boolean {
    return globals.isLargeBreakpointWidthOfSp;
  }
  get isRegifted() {
    return auth.user?.allow_points_regifting;
  }
  mounted() {
    console.log("general/components/pages/TopPage.vue mounted."); // このファイルがレンダリングされている確認のためにログを入れたが、ログ出力されない。
    this.headerHeightToChild = this.headerHeight;
    window.addEventListener("resize", this.handleResize);
    // const userDetailStr = LocalStorage.getItem("userDetails");
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  private handleResize(): void {
    this.headerHeightToChild = this.headerHeight;
  }

  async created() {
    await globals.setLoadingProcess(true);

    await commons.setOrgPageSpecificDataFromLocalStorage();

    const userSummary: UserProfileSummary = await this.getUserProfileSummary();
    if (Object.keys(userSummary).length > 0) {
      this.theA01PointInfo.point = userSummary.total_points;
      this.theA01PointInfo.pointsExpiringSoon = userSummary.points_expire_soon;
      this.theA01PointInfo.pointsExpiringCount =
        userSummary?.points_expire_soon_count;
      this.theA01PointInfo.thanksExclusivePoint =
        userSummary?.thanks_exclusive_points;
      this.theA01PointInfo.pointsLoaded = true;
      this.theA01PointInfo.grantPoints =
        userSummary?.grant_points + userSummary?.kenko_points;
      this.theA01PointInfo.groupBudgetPoint =
        userSummary?.group_budget_point;
    }

    AuthStorage.checkLogin();

    const pointAchivement: UserPointAchievement = await TopPageApi.getUserPointAchievement();
    if (Object.keys(pointAchivement).length > 0) {
      this.theA01PointInfo.pointAchievements = {
        cumulative_points_to_send: pointAchivement.cumulativePointsToSend,
        cumulative_thanks_points: pointAchivement.cumulativeThanksPoints,
        total_cumulative_points: pointAchivement.totalCumulativePoints,
        total_cumulative_group_budget_points: pointAchivement.totalCumulativeGroupBudgetPoints
      };
    }

    this.pointNoticeCards = await TopPageApi.getPointNoticeCard();
    this.members = await TopPageApi.getRandomUserAvatar();
    await TopPageApi.getLatestMessages()
    .then((latestMessages) => {
      latestMessages.map((item) => {
        this.messages.push({
          date: item.sendTime,
          message: item.messages,
          receiver: {
            icon: {
              medium: item?.toUserIcon
            }
          },
          sender: {
            icon: {
              medium: item?.fromUserIcon
            }
          }
        });
      });
    })
    .catch((e) => {
      console.log(e)
    });

    await globals.setLoadingProcess(false);
  }

  async getUserProfileSummary(): Promise<UserProfileSummary> {
    const userPointsDetails = LocalStorage.getItem("userPointsDetails")
      ? JSON.parse(LocalStorage.getItem("userPointsDetails") as string)
      : await getUserProfileSummary();

    return userPointsDetails;
  }
}
